module.exports = __webpack_public_path__ + "img/pega_recubrimientos_ceramicos_de_alta_y_media_absorcion.cfc658bc.png";